import { render, staticRenderFns } from "./OpenSeaIcon.vue?vue&type=template&id=4df4fa7f&scoped=true&"
import script from "./OpenSeaIcon.vue?vue&type=script&lang=ts&"
export * from "./OpenSeaIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4fa7f",
  null
  
)

export default component.exports